import { IconAlertTriangle } from "@tabler/icons-react"
import { type FC } from "react"

import { getAiCreditBalanceStatus } from "@forento/core/models/ai"
import { toNumberFormat } from "@forento/core/utilities/number"
import { cn } from "@forento/ui/utilities/tailwind"

import { usePlatform } from "~/contexts/UserContext"

const AiCreditBalanceWarning: FC = () => {
	const platform = usePlatform()!

	const status = getAiCreditBalanceStatus(platform.aiCreditBalance)
	if (status === "sufficient") return null

	return (
		<div
			role="status"
			className={cn(
				"flex items-start gap-2 rounded-lg border px-3 py-2 text-sm",
				status === "depleted"
					? "border-red-200 bg-red-50 text-red-700"
					: "border-amber-200 bg-amber-50 text-amber-800",
			)}
		>
			<IconAlertTriangle className="mt-0.5 size-4 shrink-0" />
			<p>
				{status === "depleted"
					? "You're out of Forento AI credits. Purchase more to keep generating."
					: `You're running low on Forento AI credits — ${toNumberFormat(platform.aiCreditBalance)} left. Top up before your next course or website generation.`}
			</p>
		</div>
	)
}

export default AiCreditBalanceWarning
